import { useSelector } from 'react-redux';
import { RootState } from '@nxsys/store';
import { canPerform } from '@nxsys/helpers/actionGate';

/**
 * Whether GET /me/actions lists `action` for the signed-in user.
 *
 * On its own this is only right for features that exist solely under IAM,
 * whose endpoints check their action in every mode. Anything older goes
 * through useActionGate, so it keeps its legacy behaviour until its module is
 * enforced.
 */
export const useCan = (action: string): boolean => {
  const actions = useSelector((state: RootState) => state.appStore.actions);
  return actions?.includes(action) ?? false;
};

/**
 * Visibility for UI that predates IAM. Once the action's module is enforced,
 * /me/actions decides; until then `legacyAllowed` does: pass today's check, or
 * leave it out where there was none.
 */
export const useActionGate = (
  declared: string | string[],
  legacyAllowed = true,
): boolean => {
  const actions = useSelector((state: RootState) => state.appStore.actions);
  const enforcedModules = useSelector(
    (state: RootState) => state.appStore.enforcedModules,
  );
  return canPerform(
    { actions: actions ?? [], enforcedModules: enforcedModules ?? [] },
    declared,
    legacyAllowed,
  );
};
